import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../css/LoginWithMpin.css";
// import logo from "../assets/icons/logo.png";
import logo from "../assets/icons/dpboss.png";
import "../css/mainhome.css";
import { AppContext } from "../context/AppContext";
import { toast } from "react-toastify";

const isMobileNotRegisteredMessage = (message = "") =>
  /mobile number .*not registered|not registered/i.test(message);

export default function LoginWithMPin() {
  const { mobileNo, setMobileNo, setUser } = useContext(AppContext);
  const [password, setPasswordLocal] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const loginMobileNo =
    mobileNo ||
    localStorage.getItem("mobileNo") ||
    localStorage.getItem("lastLoginMobileNo") ||
    "";

  useEffect(() => {
    if (loginMobileNo && !mobileNo && setMobileNo) {
      setMobileNo(loginMobileNo);
      return;
    }

    if (!loginMobileNo) {
      navigate("/enter-mobile", { replace: true });
    }
  }, [loginMobileNo, mobileNo, navigate, setMobileNo]);

  const handleLogin = async () => {
    if (!password.trim()) {
      toast.warn("Please enter your MPIN");
      return;
    }

    setIsLoading(true);

    try {
      // ✅ CORRECT SERVER
      const res = await axios.post(
        "https://admin.thedpboss.com/api/v1/reset-mpin",
        {
          mobileNo: loginMobileNo,
          password: password,
          security_pin: /^\d{4}$/.test(password) ? Number(password) : undefined,
        },
        {
          headers: {
            "Content-Type": "application/json",
            deviceId: "WEB",
            deviceName: "WEB_BROWSER",
            accessStatus: 1,
          },
        }
      );

      if (res.data.status === true) {
        const { registerId, accessToken } = res.data.info;

        // clear old tokens
        localStorage.removeItem("accessToken");
        localStorage.removeItem("registerId");

        // save new token
        localStorage.setItem("registerId", registerId);
        localStorage.setItem("accessToken", accessToken);

        // fetch profile from SAME SERVER
        const profileRes = await axios.post(
          "https://admin.thedpboss.com/api/v1/user-details-by-register-id",
          { registerId },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              Accept: "application/json",
            },
          }
        );

        if (profileRes.data.status === true && profileRes.data.info) {
          const userInfo = profileRes.data.info;
          localStorage.setItem("userProfile", JSON.stringify(userInfo));
          localStorage.setItem("walletBalance", userInfo.walletBalance);
          localStorage.setItem("mobileNo", loginMobileNo);
          localStorage.setItem("lastLoginMobileNo", loginMobileNo);

          if (setUser) setUser(userInfo);

          toast.success("Login successful!");
          navigate("/home", { replace: true });
        } else {
          toast.warn("Login successful, but failed to load profile.");
          navigate("/home", { replace: true });
        }
      } else {
        const message = res.data.msg || "Invalid MPIN. Please try again.";
        toast.error(message);

        if (isMobileNotRegisteredMessage(message)) {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("registerId");
          localStorage.removeItem("userProfile");
          if (loginMobileNo) {
            localStorage.setItem("mobileNo", loginMobileNo);
            localStorage.setItem("lastLoginMobileNo", loginMobileNo);
            if (setMobileNo) setMobileNo(loginMobileNo);
            navigate("/create-account", { replace: true });
          } else {
            navigate("/enter-mobile", { replace: true });
          }
        }
      }
    } catch (err) {
      console.error("Login process failed:", err?.response || err);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mainhome-screen-wrapper">
      <div className="top-header">Login with MPIN</div>

      <div
        className="mpin-container"
        style={{ justifyContent: "flex-start", paddingTop: "60px" }}
      >
        <img
          src={logo}
          alt="Logo"
          className="mpin-logo"
          style={{ height: "120px", marginBottom: "40px" }}
        />

        <div
          className="mpin-card"
          style={{
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
            border: "1px solid #f0f0f0",
          }}
        >
          <h2
            style={{
              fontSize: "22px",
              color: "#121212",
              marginBottom: "30px",
            }}
          >
            Login
          </h2>

          <div
            className="input-group"
            style={{ width: "100%", marginBottom: "20px" }}
          >
            <input
              type="password"
              placeholder="Enter MPIN"
              className="mpin-input"
              style={{ textAlign: "center", fontSize: "18px" }}
              value={password}
              onChange={(e) => setPasswordLocal(e.target.value)}
              autoFocus
            />
          </div>

          <button
            className="mpin-login-btn"
            onClick={handleLogin}
            disabled={isLoading}
          >
            {isLoading ? "LOGGING IN..." : "LOGIN"}
          </button>

          <div style={{ marginTop: "20px" }}>
            <a
              href="/forgot-password"
              style={{
                color: " #fdb063",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              Forgot Password?
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
